module.exports = __webpack_public_path__ + "33bcc95cfcb1b4c5427b78095b8ecfc3.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-goodshare/src/fonts/fontello.ttf?88483298
// module id = 13
// module chunks = 0